import { IFilter } from '../../types/advancedFilters';
import { LandStatusContainer } from '../../containers/advancedFilters/LandStatusContainer';

export const landStatus: IFilter = {
  component: LandStatusContainer,
};
